<template>
    <AuthLayout>
        <CeremonyDownloadLoading :ceremony-id="ceremonyId" v-if="isLoading && ceremonyId" />
        <fullscreen-loading v-if="isLoading || isLoadingPdfExport" />

        <div v-if="!isLoading">
            <ceremony-controller
                v-if="renderMode === RENDER_MODE.SIMPLE"
                :with-status="true"
                :ceremony_id="ceremonyId"
                :communication="PLAYER_COMMUNICATION.IPC"
            >
                <template #buttons-right>
                    <button class="btn btn-xs btn-outline-primary ml-3 mr-3" @click="renderMode = RENDER_MODE.PRESENTATION">
                        {{ $t('controller.presentation_view') }}
                    </button>
                </template>

                <template #button-script="{ ceremony }">
                    <button
                        v-tooltip="$t('ceremony.save_pdf_tooltip', {type: ceremony.translated_type})"
                        class="btn btn-xs btn-outline-primary ml-3"
                        @click="saveCeremonyPdf(ceremony)"
                    >
                        {{ $t('ceremony.script') }}
                    </button>
                </template>
            </ceremony-controller>

            <CeremonyPresentationController
                v-if="renderMode === RENDER_MODE.PRESENTATION"
                :ceremony-id="ceremonyId"
                @change-mode="renderMode = $event"
            />
        </div>
    </AuthLayout>
</template>

<script setup>

    import CeremonyController from '../../controller/components/CeremonyController';
    import { computed, onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router/composables';
    import { PLAYER_COMMUNICATION } from '../../enums/player-communication';
    import { RENDER_MODE } from '../../enums/render-mode';
    import { IpcCall, ipcCall } from '../utils/ipcCall';
    import AuthLayout from './AuthLayout.vue';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import CeremonyDownloadLoading from './CeremonyDownloadLoading.vue';
    import CeremonyPresentationController from './CeremonyPresentationController.vue';
    import { notifyError, notifySuccess } from '../../utils/notify';
    import i18n from '../../utils/locale';

    const route = useRoute();

    const isLoading = ref(true);
    const isLoadingPdfExport = ref(false);
    const renderMode = ref(RENDER_MODE.PRESENTATION);

    const ceremonyId = computed(() => {
        return route.params.ceremonyId;
    });

    onMounted(() => {
        downloadCeremony(ceremonyId.value);
    });

    async function downloadCeremony(ceremonyId) {
        isLoading.value = true;

        try {
            await ipcCall(IpcCall.DownloadCeremony, {
                ceremonyId,
            });
        } finally {
            isLoading.value = false;
        }
    }

    async function saveCeremonyPdf(ceremony) {
        isLoadingPdfExport.value = true;

        try {
            await ipcCall(IpcCall.SaveCeremonyPdfExport, {
                ceremonyId: ceremony.id,
                name: ceremony.name,
                date: ceremony.date
            });

            notifySuccess(i18n.t('ceremony.saved_ceremony_pdf', { type: ceremony.translated_type }));
        } catch (exception) {
            notifyError(exception, i18n.t('general.something_went_wrong'));
        } finally {
            isLoadingPdfExport.value = false;
        }
    }

</script>
